import { useContext } from 'react';

import {
  CurrentAdminContext,
  CurrentNetworkContext,
  CurrentUserContext,
} from 'hb-react/frontoffice/contexts/DefaultAppContexts';

export const useCurrentNetwork = () => useContext(CurrentNetworkContext);

export const useCurrentUser = () => useContext(CurrentUserContext);

export const useCurrentAdmin = () => useContext(CurrentAdminContext);
